import dayjs from "dayjs";
import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/student/Button";
import { Modal } from "@components/student/Modal";
import * as s from "./CheckoutStartDateInput.sss";
import { DatepickerInput } from "@/components/ui/DatepickerInput";
export const CheckoutStartDateInput = ({ availableDates, subscription, value, onChange, }) => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [localValue, setLocalValue] = useState(value);
    const startDate = value.format("DD MMMM YYYY");
    const maxDate = value.add(6, "month");
    const minDate = value;
    const changeStartDay = (date) => {
        onChange(dayjs(date));
        setLocalValue(dayjs(date));
    };
    return (React.createElement("div", { className: s.root },
        React.createElement("div", { className: s.startDateText },
            React.createElement("p", null,
                t(`student~Абонемент почне діяти з `),
                " ",
                React.createElement("button", { type: "button", onClick: () => setIsModalOpen(true), className: s.date }, startDate)),
            subscription.isFlexible && (React.createElement("p", null, t(`Ви можете змінити дату активації обравши будь-яку дату по ${maxDate.format("DD MMMM YYYY")} включно.`))),
            React.createElement("button", { type: "button", className: s.changeDateButton, onClick: () => setIsModalOpen(true) }, t("student~Изменить"))),
        React.createElement(Modal, { className: s.modal, isOpen: isModalOpen, theme: "orange", withClose: true, onRequestClose: () => setIsModalOpen(false) },
            React.createElement("div", { className: s.modalTitle }, t("student~Начало действия абонемента")),
            React.createElement("div", { className: s.modalText }, t("student~Если вы хотите отложить начало действия абонемента, " +
                "выберите подходящую дату из списка ниже")),
            React.createElement(DatepickerInput, { onChange: changeStartDay, maxDate: maxDate, minDate: minDate, value: value }),
            React.createElement(Button, { className: s.saveChanges, theme: "secondaryOrange", onClick: () => {
                    setIsModalOpen(false);
                    onChange(localValue);
                } }, t("student~Сохранить изменения")))));
};
